<template>
    <div v-if="data && data.detail" class="highlights-detail">
        <img v-src="data.detail.img" class="base-banner" alt="" />
        <div class="box">
            <div v-if="data.detail.schemeTitle">
                <div class="tem-title">{{ data.detail.headTitle || '方案标题' }}</div>
                <RichText :data="data.detail.schemeTitle"></RichText>
            </div>
            <div v-if="data.detail.desc">
                <div class="tem-title">{{ data.detail.descTitle || '方案描述' }}</div>
                <RichText :data="data.detail.desc"></RichText>
            </div>
        </div>
        <div class="list">
            <recommendProducts v-if="product.length" :isGroup="isGroup" :list="product"></recommendProducts>
            <div v-if="relatedProduct.length">
                <div class="tem-title">相关产品</div>
                <relatedListVue
                    :list="relatedProduct"
                    @go="goLink"
                ></relatedListVue>
            </div>
            <div v-if="application.length">
                <div class="tem-title">相关应用</div>
                <div class="product application">
                    <div
                        v-for="item in application"
                        :key="item.id"
                        @click="goLink(item)"
                        class="item base-shadow"
                    >
                        <div class="banner">
                            <img :src="item.detail.img" alt="" />
                        </div>
                        <div>
                            <p>{{ item.detail.desc }}</p>
                            <p class="name">{{ item.detail.name }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="article.length">
                <div class="tem-title">相关文章</div>
                <div class="article">
                    <div
                        v-for="item in article"
                        :key="item.id"
                        @click="goLink(item)"
                        class="item"
                    >
                        <div class="name">{{ item.detail.name }}</div>
                        <!-- <div class="banner">
                            <img :src="item.detail.img" alt="" />
                            <div @click.stop="star({id: item.id,...item.detail})">{{ bookDic[item.id] ? '已收藏' : '收藏' }}</div>
                        </div> -->
                        <div
                            class="banner"
                            v-lazy:background-image="item.detail.img"
                        >
                            <div
                                class="star-wrapper"
                                @click.stop="
                                    star({ id: item.id, ...item.detail })
                                "
                            >
                                <van-icon
                                    class="star"
                                    :name="bookDic[item.id] ? 'star' : 'star-o'"
                                ></van-icon>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
const { CMS } = window.env
import {
    concatWithSymbol,
    getDataHierarchy,
    getDataRow,
    sleep
} from '@custouch/proxy-use'
import RichText from '@/views/components/RichText.vue'
import relatedListVue from './components/relatedList.vue'
import bookMarksAction from '@/views/mixins/bookMarksAction'
import recommendProducts from './components/recommendProducts.vue'
export default {
    props: ['rId', 'hId', 'title'],
    mixins: [bookMarksAction],
    data() {
        return {
            data: {},
            product: [],
            isGroup: '',
            relatedProduct: [],
            application: [],
            article: []
        }
    },
    components: { RichText, relatedListVue, recommendProducts },
    async created() {
        this.bindBookMarks()
        this.data = await getDataRow({ dataRowId: this.rId })
        if (this.data.dataRows.length) {
            // 推荐产品
            this.isGroup = this.data.detail.isGroup
            this.product = this.data.dataRows.filter(
                item => item.dataTemplateId === CMS.template.highlightsProduct
            )
            // 关联产品介绍
            this.relatedProduct = this.data.dataRows.filter(
                item =>
                    item.dataTemplateId ===
                    CMS.template.highlightsRelatedProduct
            )
            // 相关应用
            this.application = this.data.dataRows.filter(
                item =>
                    item.dataTemplateId === CMS.template.highlightsApplication
            )
            // 相关文章
            this.article = this.data.dataRows.filter(
                item => item.dataTemplateId === CMS.template.highlightsArticle
            )
        }
        let path = this.data.detail.name
        if (this.hId) {
            const hInfo = await getDataHierarchy({ dataHierarchyId: this.hId })
            path = concatWithSymbol([hInfo.name, path])
        }
        this.$root.$emit('actionview', {
            info: {
                title: concatWithSymbol([this.title, path]),
                tagIds: this.data.tagIds
            },
            actionType: 'pageview'
        })
    },
    methods: {
        async goLink(item) {
            if (item.detail.link) {
                this.$root.$emit('actionview', {
                    info: {
                        remark: `点击跳转至站外链接-${item.detail.name}`,
                        to: item.detail.link
                    },
                    actionType: 'clickview'
                })
                await sleep(150)
                window.location.href = item.detail.link
            }
        }
    }
}
</script>
<style lang="less" scoped>
@import '~@/assets/style/mixin.less';
.highlights-detail {
    background: #f9f9f9;
    .base-banner {
        height: 8rem;
        vertical-align: top;
    }
    .box {
        padding: @spacing @padding-md @padding-md;
        background: @white;
        & > div:not(:last-child) {
            margin-bottom: @padding-base * 5;
        }
    }
    .tem-title {
        color: @green;
        font-weight: @font-weight-bold;
        font-size: @font-size-lg;
        line-height: @line-height-md;
        display: flex;
        align-items: center;
        margin-bottom: @padding-md;
        &::before {
            content: '';
            display: inline-block;
            width: 0.2rem;
            height: 0.8rem;
            background: #00a6eb;
            margin-right: 0.5rem;
        }
    }
    .list {
        padding: @padding-lg @padding-md;
        .product {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            grid-template-rows: auto;
            gap: @padding-md;
        }
        & > div:not(:last-child) {
            padding-bottom: @padding-xs;
        }
        .banner {
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
        .application {
            padding-bottom: @padding-md;
            .item {
                padding: @padding-xs @padding-xs @padding-sm;
                background: @white;
                border-radius: @border-radius-sm + @border-radius-md;
                color: @green;
                line-height: @line-height-md;
                .banner {
                    width: 100%;
                    height: 4.15rem;
                    margin-bottom: @padding-sm;
                    img {
                        border-radius: @border-radius-md;
                    }
                }
                .name {
                    font-weight: @font-weight-bold;
                    margin-top: 0.3rem;
                }
            }
        }
        .article {
            .item {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding-bottom: @padding-sm;
                border-bottom: 1px solid #ebebeb;
                margin-bottom: @padding-sm;
                color: @green;
                .name {
                    .ellipsis;
                    padding-right: @padding-lg;
                }
                .banner {
                    width: 5rem;
                    height: 3.6rem;
                    background: transparent no-repeat center/cover;
                    position: relative;
                    flex-shrink: 0;
                    .star-wrapper {
                        cursor: pointer;
                        position: absolute;
                        right: -0.4rem;
                        top: 0.4rem;
                        background: url('~@/assets/imgs/组 329@3x.png')
                            no-repeat center/contain;
                        width: 1.3rem;
                        height: 1.1rem;
                        color: @blue;
                        .flex();
                        justify-content: center;
                        padding-top: 0.2rem;
                        font-size: 0.6rem;
                    }
                }
            }
        }
    }
}
</style>
<style lang="less">
.highlights-detail {
    .list-icon {
        height: @font-size-md;
    }
    .van-collapse-item {
        margin-bottom: @padding-md;
        .van-collapse-item__title {
            align-items: center;
            box-shadow: 0 0.05rem 0.2rem 0 #004da029;
            background: @white;
            border-radius: @border-radius-sm + @border-radius-md;
            color: @green;
            font-size: @font-size-lg;
            line-height: @line-height-md;
        }
        .van-collapse-item__content {
            padding: @padding-md 0 @padding-xs;
            background: transparent;
        }
    }
}
</style>
